import { resolveWorkspaceFeatureAccess } from "../../utils/workspaceFeatures";
import { resolveSystemTypeConfig } from "../../utils/resolveSystemTypeConfig";
import { INTERNATIONAL_CURRENCY } from "../../constants/feeAudience";
import { appliedFollowUp } from "./followUpSlice";
function amountOf(value) {
    const amount = typeof value === "string" && value.trim() !== "" ? Number(value) : value;
    return typeof amount === "number" && Number.isFinite(amount) && amount >= 0
        ? amount
        : null;
}
function quoted(amount, currency) {
    const value = amountOf(amount);
    return value !== null && typeof currency === "string" && currency.trim()
        ? { amount: value, currency: currency.trim() }
        : null;
}
export function planQuotesFrom(plans, bookedLength, queueCurrency) {
    const visit = plans.find((plan) => plan.kind === "GENERAL_CONSULTATION" &&
        plan.isFollowUp !== true &&
        (bookedLength == null ||
            plan.durationMins == null ||
            plan.durationMins === bookedLength));
    const packs = {};
    for (const plan of plans) {
        if (plan.kind !== "SESSION_PACK")
            continue;
        const total = quoted(plan.totalPrice, plan.currency);
        const perSession = amountOf(plan.pricePerSession);
        if (!total || perSession === null)
            continue;
        packs[String(plan.id)] = {
            ...total,
            perSession,
            listAmount: amountOf(plan.originalPrice),
        };
    }
    return {
        singleVisit: visit ? quoted(visit.pricePerSession, visit.currency) : null,
        packs,
        queueCurrency: queueCurrency?.trim() || null,
    };
}
function queueCharge(state) {
    const shift = state.selectedSlot;
    if (!shift)
        return null;
    const international = state.feeAudience === "INTERNATIONAL";
    const amount = amountOf(international ? shift.internationalFee : shift.consultationFee);
    const currency = international
        ? INTERNATIONAL_CURRENCY
        : state.planQuotes.queueCurrency;
    return amount !== null && currency
        ? { kind: "CONSULTATION", amount, currency }
        : null;
}
export function quoteCharge(state) {
    if (resolveSystemTypeConfig(state.activeSystemType).bookingMode === "qms") {
        return queueCharge(state);
    }
    const features = resolveWorkspaceFeatureAccess(state.workspace);
    if (features.packageUsage && state.selectedActiveSessionPack) {
        return { kind: "ACTIVE_PACK" };
    }
    if (features.packagePurchase && state.selectedPack) {
        const pack = state.planQuotes.packs[String(state.selectedPack.id)];
        return pack
            ? {
                kind: "PACK_PURCHASE",
                amount: pack.amount,
                currency: pack.currency,
                packName: state.selectedPack.packageName ?? null,
            }
            : null;
    }
    const followUp = appliedFollowUp(state);
    if (followUp) {
        return typeof followUp.discountedFee === "number" && followUp.currency
            ? {
                kind: "FOLLOW_UP",
                amount: followUp.discountedFee,
                currency: followUp.currency,
            }
            : null;
    }
    const visit = state.planQuotes.singleVisit;
    return visit
        ? { kind: "CONSULTATION", amount: visit.amount, currency: visit.currency }
        : null;
}
export function requireQuotedCharge(state) {
    const charge = quoteCharge(state);
    if (!charge) {
        throw new Error(`No price was quoted for this ${state.consultationMode} booking.`);
    }
    return charge;
}
